var _path, _path2, _circle, _circle2, _circle3, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "analysis",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.038,
    height: 20.038,
    viewBox: "0 0 20.038 20.038",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M8.2,12.762a.626.626,0,0,1-.529-.958l1.97-3.139a.626.626,0,0,1,1.06.665l-1.97,3.139a.626.626,0,0,1-.531.293Z",
    transform: "translate(-1.25 -1.382)",
    fill: "#707070"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M14.315,6.81a.627.627,0,0,1-.136-1.238l3.44-.768a.627.627,0,0,1,.274,1.223l-3.44.768a.656.656,0,0,1-.138.015Z",
    transform: "translate(-2.26 -0.791)",
    fill: "#707070"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(3 10)",
    fill: "#707070"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4",
    "data-name": "Ellipse 4",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(8 3)",
    fill: "#707070"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(15 2)",
    fill: "#707070"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M1.835,20.038A.835.835,0,0,1,1,19.2V.835a.835.835,0,0,1,1.67,0V19.2A.835.835,0,0,1,1.835,20.038Z",
    transform: "translate(-0.165)",
    fill: "#707070"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M19.2,22.67H.835a.835.835,0,0,1,0-1.67H19.2a.835.835,0,0,1,0,1.67Z",
    transform: "translate(0 -3.467)",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine);
export default __webpack_public_path__ + "static/media/line.1bde7b52edd7cf9bd61aceacb30db546.svg";
export { ForwardRef as ReactComponent };